<div class="services-block">
  <div class="common-section-wrapper common-section-wrapper--services">
    <div class="common-container">
      <h3 class="common-section-title">{{ lg.servicesBlock.heading }}</h3>
      @for (service of services; track service) {
        <bmcore-service-item [service]="service"></bmcore-service-item>
      }
      <div class="common-btn-container">
        <bmcore-button title="{{ lg.button.showServices }}" [routerPath]="'services'" icon="btv-icon-btn-list">
        </bmcore-button>
      </div>
    </div>
  </div>
</div>
